import { Button, message, Tag, Image, Row, Col, InputNumber } from "antd";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { useCart } from "../../context/CartContext";
import "../../css/product.css";
export default function ProductDetailContent({ product, allProducts = [] }) {
  const [selectedProduct, setSelectedProduct] = useState(product);
  const [qty, setQty] = useState(1);
  const [inCart, setInCart] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const { items, addItem, updateQty } = useCart();

  // products with same model + subcategory
  const colorProducts = (allProducts || []).filter(
    (p) =>
      p.subcategory_id === product.subcategory_id &&
      p.model_id === product.model_id,
  );

  useEffect(() => {
    const item = items.find((c) => c.productId === selectedProduct.id);

    const images = getImages();
    setSelectedImage(images[0] || "/uploads/placeholder.jpg");

    if (item) {
      setInCart(true);
      setQty(item.qty);
    } else {
      setInCart(false);
      setQty(1);
    }
  }, [selectedProduct, items]);

  const subCategoryData = selectedProduct.subcategory;
  const productDescription =
    selectedProduct?.description || selectedProduct.subcategory?.description;

  const getImages = () => {
    if (selectedProduct.images?.length) {
      return selectedProduct.images.map((i) => i.image_url);
    }
  };

  const productImage = selectedProduct.images?.[0]?.image_url;

  const images = getImages();

  const productBasePrice = product.base_price;
  const productDiscountPrice = product.discount_price;

  const basePrice =
    productBasePrice && Number(productBasePrice) > 0
      ? Number(productBasePrice)
      : Number(subCategoryData?.base_price || 0);

  const discountPrice =
    productDiscountPrice && Number(productDiscountPrice) > 0
      ? Number(productDiscountPrice)
      : Number(subCategoryData?.discount_price || 0);

  const handleAddToCart = async () => {
    try {
      const existing = items.find((i) => i.productId === selectedProduct.id);

      if (existing) {
        console.log("existing" + JSON.stringify(existing));
        // 🔄 UPDATE
        await api.put(`/cart/${existing.cartId}`, {
          quantity: qty,
        });

        updateQty(existing.variantId, qty);

        message.success("Cart updated");
      } else {
        // ➕ ADD
        const res = await api.post("/cart", {
          product_id: selectedProduct.id,
          quantity: qty,
        });

        addItem(
          selectedProduct,
          {
            id: selectedProduct.id,
            price: discountPrice || basePrice,
          },
          qty,
          res.data.id, // 🔥 cartId
        );

        message.success("Added to cart");
      }

      setInCart(true);
    } catch (err) {
      message.error("Cart failed");
    }
  };

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 20, width: "100%" }}>
      {/* LEFT SIDE */}
      <Col xs={24} md={12}>
        <Image
          src={`${process.env.REACT_APP_API_URL}${selectedImage}`}
          style={{
            width: "100%",
            maxHeight: 350,
            objectFit: "contain",
          }}
        />

        {/* Display all images hre */}
        <Row gutter={8} style={{ marginTop: 15 }}>
          {images.map((img, index) => (
            <Col key={index}>
              <Image
                preview={false}
                width={70}
                src={`${process.env.REACT_APP_API_URL}${img}`}
                style={{
                  cursor: "pointer",
                  border:
                    selectedImage === img
                      ? "2px solid #1677ff"
                      : "1px solid #eee",
                  padding: 3,
                }}
                onClick={() => setSelectedImage(img)}
              />
            </Col>
          ))}
        </Row>
      </Col>

      {/* RIGHT SIDE */}
      <Col xs={24} md={12}>
        <h2>{selectedProduct.name}</h2>

        {productDescription?.includes("|") ? (
          <ul>
            {productDescription.split("|").map((p, i) => (
              <li key={i}>{p.trim()}</li>
            ))}
          </ul>
        ) : (
          <p>{productDescription}</p>
        )}

        {selectedProduct?.models?.length > 0 && (
          <div className="mt-3">
            <strong>Compatible Models</strong>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                marginTop: 8,
              }}
            >
              {product.models.map((model) => (
                <Tag key={model.id}>{model.name}</Tag>
              ))}
            </div>
          </div>
        )}

        {/* PRICE */}
        <strong style={{ marginTop: 15, display: "block" }}>Price:</strong>
        {discountPrice > 0 ? (
          <>
            <div className="price-detail-wrapper">
              <span className="price-base">£{basePrice}</span>
              <span className="price-discount">£{discountPrice}</span>
            </div>
          </>
        ) : (
          <div className="price-normal">£{basePrice}</div>
        )}

        {/* ATTRIBUTES */}
        <div style={{ marginTop: 15 }}>
          {selectedProduct.attributes?.map((attr) => (
            <Tag key={attr.id} color="blue">
              {attr.Attribute?.name}: {attr.AttributeValue?.value}
            </Tag>
          ))}
        </div>

        {/* COLOR OPTIONS */}
        <div style={{ marginTop: 20 }}>
          <strong>Variants:</strong>
          <Row gutter={10} style={{ marginTop: 8 }}>
            {colorProducts.map((p) => {
              const color = p.attributes?.find(
                (a) => a.Attribute?.name === "Colors",
              )?.AttributeValue?.value;

              return (
                <Tag
                  key={p.id}
                  color={selectedProduct.id === p.id ? "green" : "default"}
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedProduct(p)}
                >
                  {color}
                </Tag>
              );
            })}
          </Row>
        </div>

        {/* QUANTITY */}
        <div style={{ marginTop: 20 }}>
          <strong>Quantity</strong>
          <br />

          <InputNumber min={1} value={qty} onChange={setQty} />
        </div>

        {/* CART BUTTON */}
        <div style={{ marginTop: 20 }}>
          <Button
            type="primary"
            style={{
              background: inCart ? "#52c41a" : undefined,
            }}
            onClick={handleAddToCart}
          >
            {inCart ? "Update Cart" : "Add To Cart"}
          </Button>
        </div>

        <Row gutter={8} style={{ marginTop: 15 }}>
          {colorProducts.map((p) => {
            const img =
              p.images?.[0]?.image_url ||
              p.subcategory?.colorImages?.[0]?.image_url;

            return (
              <Col key={p.id}>
                <Image
                  width={70}
                  preview={false}
                  src={`${process.env.REACT_APP_API_URL}${img}`}
                  style={{
                    border:
                      selectedProduct.id === p.id
                        ? "2px solid #1677ff"
                        : "1px solid #eee",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedProduct(p)}
                />
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
